import React from "react";

export const SocFacebookIcon = () => {
  return (
    <svg
      width="13"
      height="25"
      viewBox="0 0 13 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6641 4.15104H12.9464V0.176042C12.5526 0.121875 11.1984 0 9.62136 0C6.33073 0 4.07656 2.06979 4.07656 5.87396V9.375H0.445312V13.8187H4.07656V25H8.52865V13.8198H12.013L12.5661 9.37604H8.52761V6.31458C8.52865 5.03021 8.87448 4.15104 10.6641 4.15104Z"
        fill="inherit"
      />
    </svg>
  );
};
